import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

function Pricing() {
  return (
    <>
      <Helmet>
        <title>WebsiteSEO</title>
        <meta name="description" content={"Website SEO"} />
        <meta name="keywords" content={"Website SEO  "} />
        <link rel="canonical" href={"https://www.websiteseo.ae/Pricing"} />
        <script type="application/ld+json">
          {JSON.stringify({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Websiteseo",
  "url": "https://www.websiteseo.ae/",
  "logo": {
    "@type": "ImageObject",
    "url": "https://www.websiteseo.ae/images/img/logo.png"
  },
  "description": "WebsiteSEO is a digital solutions agency offering website design and development, SEO, mobile app development, domain registration, web hosting, social media marketing, email marketing, SMS marketing, branding, and online marketing services to help businesses build and strengthen their digital presence.",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Office# 114 Al Ahbabi Building Damascus Street, Al Qusais Dubai, United Arab Emirates",
    "addressLocality": "Dubai",
    "addressRegion": "Dubai",
    "postalCode": "00000",
    "addressCountry": "UAE"
  },
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "telephone": "+971 55 570 9788",
      "contactType": "customer service",
      "email": "sales@websiteseo.ae"
    }
  ]
})}
        </script>
      </Helmet>

<div>
  {/* HEADER
  ============================================= */}
  {/* END HEADER */}
  {/* HERO
  ============================================= */}
  <div className="inner-page-banner-wrap" style={{backgroundImage: 'url(/legacy/images/img/inner-banner-bg.jpg)', backgroundSize: 'cover', backgroundAttachment: 'fixed'}}>
    <div className="container">
      <h3>Pricing</h3>
      <ul>
        <li><Link to="/">Home</Link></li>
        <li>Pricing</li>
      </ul>
    </div>
  </div>
  <section id="integrations" className="py-100 integrations-2 integrations-section division">
    <div className="container">
      <div className="posts-wrapper ">
        <div className="row">
          <div className="col-md-3" />
          <div className="col-md-6">
            <div className="form-wrapper bsd">
              <h5 className="mb-20">Contact us now</h5>
              <form id="contactform1" className="row contact-form">
                <div id="response1" />
                <input type="text" name="cf_fname" id="cf_fname" className="form-control name" placeholder="Name *" required />
                <input type="text" name="cf_phone" id="cf_phone" className="form-control name" placeholder="Contact Number *" required />
                <input type="email" name="cf_email" id="cf_email" className="form-control email" placeholder="Email Address *" required />
                <textarea className="form-control message" name="cf_msg" id="cf_msg" rows={6} placeholder="Message" defaultValue={""} />
                {/* Contact Form Button */}
                <div className="form-btn">
                  <button type="submit" className="btn btn--blue hover--tra-black submit">Submit Request</button>
                </div>
                {/* Contact Form Message */}
                <div className="contact-form-msg">
                  <span className="loading" />
                </div>
              </form>  {/* End contact-form */}
            </div>
          </div>
        </div>  {/* End row */}
      </div>
    </div>     {/* End container */}
  </section>
  {/* FOOTER
  ============================================= */}
  {/* END FOOTER */}
</div>

    </>
  );
}

export default Pricing;
